import USER_ROLES from "../../../../../constants/userRoles.constants";

class AspectController {
    constructor(
        stepLearningEngagementService,
        evaluationService,
        userService,
        $q,
        $stateParams,
        $state,
        $mdDialog,
        $mdToast,
    ) {
        const currentEvalId = $stateParams.id;
        this.currentAspectNr = $stateParams.aspectNr || 0;
        this.$mdToast = $mdToast;
        this.$state = $state;
        this.stateChangeCheck = true;
        this.isFinished = false;
        this.isAdmin = false;
        this.isManager = false;
        this.showOthers = false;
        this.othersScores = [];
        this.exportedData = {};
        this.uploadError = {};

        this.getAspects = () => {
            stepLearningEngagementService.getAspects().then((data) => {
                this.aspects = data;
                if (this.currentAspectNr) {
                    this.currentAspect = this.aspects[this.currentAspectNr];
                }
                evaluationService.getEvaluationData(currentEvalId, true).then((data) => {
                    this.isFinished = evaluationService.isAfterFinish(data.status);
                    this.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);
                    this.isManager = data.isManager;
                    this.answersData = data.learningEngagement ? data.learningEngagement : [];

                    const currentData = this.answersData.find(answerData => answerData.aspect.id === this.currentAspect.id);
                    if(currentData) {
                        this.currentAspect = currentData.aspect;
                        this.currentAspect.strengthsImage = currentData.strengthsImage;
                        this.currentAspect.strengths = currentData.strengths;
                        this.currentAspect.developmentAreas = currentData.developmentAreas;
                        this.currentAspect.developmentAreasImage = currentData.developmentAreasImage;
                        this.currentAspect.questions.forEach(question => {
                            question.averageScore = 0;
                            question.score = 0;
                            currentData.answers.some(answer => {
                                if (question.id === answer.question.id) {
                                    question.score += parseInt(answer.score);
                                    question.averageScore += parseInt(answer.score);
                                    return true;
                                }
                            });
                        });
                    } else {
                        this.currentAspect.questions.forEach(question => {
                            question.score = 0;
                            question.averageScore = 0;
                        });
                    }

                    if(this.isFinished) {
                        if(data.learningEngagementsSummary) {
                            const currentSummaryAspect = data.learningEngagementsSummary
                                .find(answerData => answerData.aspect.id === this.currentAspect.id);

                            if(currentSummaryAspect) {
                                this.exportedData.strengths = currentSummaryAspect.strengths;
                                this.exportedData.developmentAreas = currentSummaryAspect.developmentAreas;
                                currentSummaryAspect.questions.forEach((questionData) => {
                                    this.currentAspect.questions.some(question => {
                                        if (question.id === questionData.question.id) {
                                            question.strengths = questionData.strengths;
                                            question.developmentAreas = questionData.developmentAreas;
                                            return true;
                                        }
                                    });
                                });
                                this.exportedDataPristine = JSON.parse(angular.toJson(this.exportedData));
                            }
                        }
                        $q.all([
                            evaluationService.getOthers('learning_engagements', data.isMini, data.id),
                            stepLearningEngagementService.getLearningEngagementsSummary(currentEvalId)
                        ]).then(res => {
                            this.summaryData = res[1].find(othersAverages => othersAverages.aspect.id === this.currentAspect.id);
                            this.othersScores = res[0].map(other => {
                                return {
                                    ...other.learningEngagements.find(answerData => answerData.aspect.id === this.currentAspect.id),
                                    user: other.user
                                };
                            });

                            if (this.othersScores.length && this.summaryData) {
                                this.currentAspect.questions.forEach(question => {
                                    question.averageScore = question.averageScore == null ? 0 : question.averageScore;
                                    this.summaryData.questions.some(averageQuestion => {
                                       if(averageQuestion.question.id === question.id) {
                                           question.averageScore = averageQuestion.score;
                                           return true;
                                       }
                                    });

                                });
                            }
                        });
                    }

                    this.currentAspectPristine = JSON.parse(angular.toJson(this.currentAspect));
                });
            });
        };

        this.getAspects();

        this.saveExportData = (redirect) => {
            const exportedData = {
                ...this.exportedData,
                'aspectId': this.currentAspect.id,
                'questions': []
            };
            this.currentAspect.questions.forEach(question => {
                exportedData.questions.push({
                    questionId: question.id,
                    strengths: question.strengths === true,
                    developmentAreas: question.developmentAreas === true,
                });
            });

            stepLearningEngagementService.saveExportedAnswers(currentEvalId, exportedData).then(() => {
                this.$mdToast.show(
                    this.$mdToast.simple()
                        .textContent('Your data has been saved successfully')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass("success-toast")
                );
                if(redirect) {
                    const isLastIndex = this.currentAspect.id === this.aspects[this.aspects.length - 1].id;
                    if (isLastIndex) {
                        this.$state.go('mini.conclusions', {id: currentEvalId});
                    } else {
                        this.$state.go('mini.learningEngagement.aspect', {
                            id: currentEvalId,
                            aspectNr: parseInt(this.currentAspectNr) + 1
                        });
                    }
                }
            });
        };

        this.handleNextButton = (redirect) => {
            let answersArray = [];
            this.currentAspect.questions.forEach(
                function(question) {
                    if (question.score) {
                        answersArray.push({
                            questionId: question.id,
                            score: question.score
                        });
                    }
                });
            let answersData = {
                aspectId: this.currentAspect.id,
                aspect: this.currentAspect.name,
                strengths: this.currentAspect.strengths,
                strengthsImage: this.currentAspect.strengthsImage &&
                    !(this.currentAspect.strengthsImage.indexOf('api/uploads') > -1) ? this.currentAspect.strengthsImage : null,
                developmentAreasImage: this.currentAspect.developmentAreasImage &&
                    !(this.currentAspect.developmentAreasImage.indexOf('api/uploads') > -1)  ? this.currentAspect.developmentAreasImage : null,
                developmentAreas: this.currentAspect.developmentAreas,
                answers: answersArray
            };

            this.stateChangeCheck = false;
            stepLearningEngagementService.saveAnswers(currentEvalId, answersData, this.currentAspectNr, true, redirect);
        };

        this.calculateMarksMean = (fieldName) => {
            this.mean = 'not calculated';
            let sum = 0;
            let divisor = 0;
            let markInt;
            this.currentAspect.questions.forEach(item => {
                    markInt = parseInt(item[fieldName]);
                    if (markInt) {
                        divisor += 1;
                        sum += markInt;
                    }
                }
            );
            if (divisor !== 0) {
                this.mean = sum / divisor;
            }
        };

        this.showEditAspect = () => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'editAspectsDialog.tmpl.html',
                parent: angular.element(document.body),
                locals: {
                    curraspectname: this.currentAspect.name
                },
                controller: function DialogController($scope, $mdDialog, curraspectname) {
                    $scope.closeDialog = function() {
                        $mdDialog.hide();
                    };
                    $scope.curraspectname = curraspectname;
                }
            })
            .then(function() {
                this.getAspects();
            }, function() {});
        };

        this.onPictureUpload = (file, obj, field) => {
            evaluationService.convertImageToBase64(file)
                .then((res) => {
                    if (res) {
                        this.uploadError[field] = null;
                        obj[field] = res.replace(/^.+base64,/, '');
                    }
                })
                .catch((error) => {
                    this.uploadError[field] = error.status;
                });
        };
    }

    $onDestroy() {
        if (!this.isFinished && this.stateChangeCheck && !angular.equals(this.currentAspect, this.currentAspectPristine)) {
            this.handleNextButton(false);
        } else if (this.isFinished && this.stateChangeCheck && ((!angular.equals(this.currentAspect, this.currentAspectPristine))
            || (!angular.equals(this.exportedData, this.exportedDataPristine)))) {
            this.saveExportData(false);
        }
    }

    calculateAverageScoreFrom(fieldName) {
        const filter = this.currentAspect.questions.filter(question => question[fieldName] !== 0);
        const sum = filter.reduce((acc, question) => acc + question[fieldName], 0);

        return sum === 0 ? '-' : (sum / filter.length).toFixed(3);
    }
}

export default AspectController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningEngagement/pages/aspectController.js